// Shared constants for the client.
// Keep DEPARTMENTS in sync with store.ValidDepartments in server/store/store.go --
// the server rejects any department not in that list.
export const DEPARTMENTS = ['bakery', 'dairy', 'deli', 'frozen', 'grocery', 'meat', 'produce', 'other'];

export const titleCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');
